import React, { Component } from 'react';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import AuthService from '../AuthService';
import axios from 'axios';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  dialog: {
    color: '#455560'
  }
});

class CancelDocumentDialog extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      cancelReason: '',
      notifyParticipants: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.cancelDocument = this.cancelDocument.bind(this);
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  cancelDocument() {
    const cancelReason = this.state.cancelReason,
      notifyParticipants = this.state.notifyParticipants,
      data = {
        cancelReason: cancelReason,
        notifyParticipants: notifyParticipants
      };

    return axios(
      `${process.env.REACT_APP_API_URL}/documents/kiosk/cancel/` +
        this.props.document.id,
      {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data)
      }
    ).then(response => {
      if (response.status === 200) {
        this.props.updateDocuments();
        this.props.onClose();
      }
      return response.data;
    });
  }

  render() {
    const { classes, fullScreen } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleCloseCancelDialog}
          aria-labelledby="form-dialog-title"
          fullScreen={fullScreen}
        >
          <DialogTitle id="form-dialog-title">Cancel Document</DialogTitle>
          <DialogContent>
            <DialogContentText
              classes={{ root: classes.dialog }}
              className={classes.dialog}
            >
              Are you sure you wish to cancel {this.props.document.name}?
            </DialogContentText>
            <FormGroup>
              <TextField
                autoFocus
                margin="dense"
                id="cancelReason"
                name="cancelReason"
                value={this.state.cancelReason}
                onChange={this.handleChange}
                label="Reason (optional)"
                type="text"
                fullWidth
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="notifyParticipants"
                    checked={this.state.notifyParticipants}
                    type="checkbox"
                    onChange={this.handleChange}
                    color="primary"
                  />
                }
                label="Notify Participants"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="secondary">
              No
            </Button>
            <Button onClick={this.cancelDocument} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(CancelDocumentDialog);



// WEBPACK FOOTER //
// ./src/components/CancelDocumentDialog.js